import type { RouteConfig } from 'vue-router';
import AvailabilityAggregations from './AvailabilityAggregations';

export enum Route {
  ROOT = 'availabilityAggregationsIndex',
}

const routes: RouteConfig[] = [
  {
    component: AvailabilityAggregations,
    name: Route.ROOT,
    path: '/availabilities',
  },
];

export default routes;
